import { FetchResult } from "../services/GameService";

export type GameStates = "VOID" | "RUNNING" | "COMPLETE";
export type GameState =
  | {
      state: "VOID";
    }
  | {
      state: "RUNNING";
      nonce: string;
      player: string;
      ballCount: number;
      guesses: Array<Guess>;
      rays: Array<Ray>;
      score: number;
      started: number;
    }
  | {
      state: "COMPLETE";
      nonce: string;
      player: string;
      ballCount: number;
      guesses: Array<Guess>;
      rays: Array<Ray>;
      score: number;
      balls: Array<Guess>;
      tally: Tally;
      rayPaths: RayPaths;
      started: number;
      ended: number;
    };

export type RayPaths = Array<RayPath>;

export type GameSummary = {
  state: "COMPLETE";
  nonce: string;
  player: string;
  ballCount: number;
  score: number;
  started: number;
  ended: number;
};

export type GameSummaries = Array<GameSummary>;

export type Guess = {
  location: Location;
};

export type Location = {
  x: number;
  y: number;
};

export type RayResult = "HIT" | "REFLECTION" | "DETOUR";

export type Ray = {
  entryPortOrdinal: number;
  exitPortOrdinal: number;
  result: RayResult;
  detourOrdinal: number;
};

export type Step = {
  starting: Direction;
  ending: Direction;
  location: Location;
};

export type RayPath = {
  steps: Array<Step>;
  ray: Ray;
};

export type Tally = {
  hitCount: number;
  reflectionCount: number;
  detourCount: number;
  missCount: number;
};

export type Direction = "NORTH" | "EAST" | "SOUTH" | "WEST";

export type ApiResultCallback<T> = (data: FetchResult<T>) => void;

export type Leaders = {
  for3balls: Array<GameSummary>;
  for4balls: Array<GameSummary>;
  for5balls: Array<GameSummary>;
};

export type Penalties = {
  //TODO: really needed?
  hit: number;
  reflection: number;
  detour: number;
  missed: number;
};

export type PagedResult<T> = {
  meta: PagedResultMeta;
  data: T;
};

export type PagedResultMeta = {
  pageNumber: number;
  pageSize: number;
  sortProperty: string;
  isAscending: boolean;
  totalCount: number;
};

export type FetchResultSetter<T> = React.Dispatch<React.SetStateAction<FetchResult<T>>>;

export const PLAYER_KEY = "bbui.player";
export const VOLUME_KEY = "bbui.volume";
export const BALL_COUNT_KEY = "bbui.ballCount";
export const NOTICE_SEEN_KEY = "bbui.noticed";
